"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Legacy() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3248" id="the-miss-yvonne-legacy" className="bg-[hsl(40,33%,96%)] text-[hsl(222,47%,11%)] py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-[55fr_45fr] gap-12 lg:gap-[120px] items-center">
          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative aspect-[4/5] overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_vessel.webp" alt="The Miss Yvonne fishing vessel docked at the harbor, showcasing its historic 1965 craftsmanship" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              {}
              <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6">
                <p className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.15em] text-white/85">
                  Est. 1965 &middot; Ocean Springs, MS &middot; The Miss Yvonne
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`transition-all duration-1000 ease-out delay-150 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <p className="font-mono text-xs uppercase tracking-[0.2em] mb-8 text-[hsl(215,60%,35%)]">
              N&deg; 01 &mdash; Our Heritage
            </p>

            {}
            <h2 className="font-serif font-semibold text-[36px] md:text-[48px] lg:text-[56px] leading-[0.95] tracking-[-0.03em] mb-10 text-[hsl(222,47%,11%)]">
              Built by Hand.
              <br />
              Proven by
              <br />
              <em className="italic font-normal text-[hsl(28,85%,58%)]">
                Time.
              </em>
            </h2>

            {}
            <p className="font-default text-[17px] leading-[1.6] text-[hsl(210,10%,45%)] mb-10 max-w-xl">
              The Miss Yvonne is more than a vessel; she is a testament to the enduring spirit of Gulf Coast fishing. Built in 1965, she has spent decades navigating the tides, representing a commitment to quality, hard work, and sustainable harvesting. We bring that same legacy of integrity from the open water directly to your table, ensuring every cut is as honest as the day it was caught.
            </p>

            {}
            <div className="w-[60%] mb-6">
              <div className="h-px w-full bg-[hsl(38,20%,85%)]" />
            </div>

            {}
            <p className="font-default italic text-[13px] text-[hsl(222,47%,11%)]/70 mb-10">
              &mdash; The Miss Yvonne Crew
            </p>

            {}
            <Button asChild variant="ghost" className="px-0 h-auto py-2 font-mono text-sm tracking-widest uppercase hover:bg-transparent group" style={{
            color: "hsl(28, 85%, 58%)"
          }}>
              <Link to="/OurStoryPage">
                <span className="border-b border-current pb-1 transition-all duration-300 group-hover:border-transparent">
                  Discover Our Story
                </span>
                <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}